import React from "react";
import { AccessibilityHiddenImg } from "@skillz/accessibility";
import classes from "./CreateStudyGroupCard.module.css";

const CreateStudyGroupCard = ({ group, lang, onClick, isSelected }) => {

  return (
    <div onClick={onClick} className={`${classes.OptionBtn} ${isSelected ? classes.Selected : ""}`}>
      <span className={`${classes.Radio} ${isSelected ? classes.RadioSelected : ""}`} aria-hidden="true" />
      <AccessibilityHiddenImg src={group?.imageUrl} alt={group?.name?.[lang]} className={classes.Logo} />
      <span className={classes.OptionTitle}>{group?.name[lang]}</span>
    </div>
  );
};

export default CreateStudyGroupCard;
